module.exports = __webpack_public_path__ + "img/header_tablette@2x.776c11a2.jpg";